module.exports = __webpack_public_path__ + "entry-150bfe9b/veronika-gersdorf.256x256-9ab4a007e5dfec3198fa1c08dc0d64c1.webp";